module.exports = __webpack_public_path__ + "img/step-refine.09a7d978.png";